const subscriptionManageKeys = {
  // Dialog and Steps
  "subscription.manage.dialog.step.select.title": "Actualizar suscripción",
  "subscription.manage.dialog.step.review.title": "Revisar cambios",
  "subscription.manage.dialog.step.review.action": "Actualizar plan",

  // Notifications
  "subscription.manage.notification.success.title": "Actualizado con éxito",
  "subscription.manage.notification.success.message": "¡Perfecto! Tu suscripción ha sido actualizada. Gracias por seguir con nosotros.",
  "subscription.manage.notification.success.scheduled.title": "Cambio programado",
  "subscription.manage.notification.success.scheduled.message":
    "Tu cambio de suscripción ha sido programado y entrará en vigor al inicio de tu próximo período de facturación.",
  "subscription.manage.notification.error.title": "Error al actualizar la suscripción",
  "subscription.manage.notification.error.message": "Ocurrió un error al actualizar tu suscripción. Inténtalo de nuevo.",

  // Select Step
  "subscription.manage.select.current": "Suscripción actual",
  "subscription.manage.select.total-seats": "Total de plazas",
  "subscription.manage.select.subscription": "Suscripción",
  "subscription.manage.select.add-remove": "Agregar o quitar plazas",
  "subscription.manage.select.need-more": "¿Necesitas más perfiles?",
  "subscription.manage.select.contact-us": "Haz clic aquí para contactarnos",
  "subscription.manage.select.insufficient-seats":
    'No puedes reducir a {{newQuantity}} plazas ya que tu equipo actualmente tiene {{teamSize}} miembros. Por favor ve a "Gestión de equipo" para eliminar miembros antes de reducir tu suscripción.',
  "subscription.manage.select.continue-prompt": "Haz clic en 'Continuar' para ver cómo afectan estos cambios a tu suscripción.",

  // Promo Code Messages
  "subscription.manage.promo.error.required": "Por favor ingresa un código promocional",
  "subscription.manage.promo.error.invalid": "Código promocional inválido",
  "subscription.manage.promo.error.minimum-amount":
    "Este código promocional requiere un plan de suscripción con un precio base más alto. Por favor actualiza a un plan anual o contacta a soporte para asistencia.",
  "subscription.manage.promo.billing-reset-notice":
    "Esta actualización iniciará un nuevo período de facturación inmediatamente. Recibirás crédito por el tiempo no utilizado de tu período actual.",

  // Review Step
  "subscription.manage.review.subscription": "Suscripción",
  "subscription.manage.review.seat-change": "Cambio de plazas",
  "subscription.manage.review.new-total": "Nuevo total",
  "subscription.manage.review.total-due": "Total a pagar ahora",
  "subscription.manage.review.seats": "plazas",
  "subscription.manage.review.for-period": "para el período del {{startDate}} al {{endDate}}",
  "subscription.manage.review.deferred-change": "Sin cargo ahora. Este cambio entrará en vigor el {{date}}.",
  "subscription.manage.review.added-seats-charge": "Cargo por {{count}} plaza(s) adicional(es) para {{startDate}} - {{endDate}}",

  // Adjustments Section
  "subscription.manage.review.prorated-adjustment": "Ajuste prorrateado",
  "subscription.manage.review.applied-discount": "Descuento aplicado",
  "subscription.manage.review.applied-discounts-multiple": "Descuentos aplicados",
  "subscription.manage.review.discount-percent": "({{percent}}% de descuento)",
  "subscription.manage.review.credit-added": "Crédito añadido",
  "subscription.manage.review.applied-savings": "Ahorros aplicados",

  // Info Messages
  "subscription.manage.info.subscription-change":
    "Tu cambio de suscripción generó un ajuste prorrateado por la parte no utilizada del plan anterior. Este crédito se aplicará a futuros cargos.",
  "subscription.manage.info.credit-added": "Se ha añadido un crédito a tu cuenta que estará disponible para futuros pagos.",
  "subscription.manage.info.savings-applied": "Se han aplicado automáticamente los ahorros de plazas eliminadas previamente a esta compra.",
  "subscription.manage.info.decrease-seats":
    "La disminución de plazas generó un ajuste prorrateado. Este monto se acreditará en tu cuenta para futuros cargos.",
  "subscription.manage.info.charged-remaining": "Solo se te cobrará por las nuevas plazas por el tiempo restante del período de facturación actual.",
  "subscription.manage.info.renewal":
    "Tus plazas totales se {{action}} a {{count}}. Tu plan se renovará el {{date}} por {{amount}} cada {{interval}}.",
  "subscription.manage.info.increase": "aumentarán",
  "subscription.manage.info.decrease": "disminuirán",
  "subscription.manage.info.year": "año",
  "subscription.manage.info.month": "mes",
  "subscription.manage.info.deferred-decrease":
    "Tu suscripción disminuirá a {{count}} plazas el {{date}}. Tu próximo cargo será de {{amount}} por {{interval}}.",
  "subscription.manage.info.custom-invoice-added-seats":
    "Se te cobrará ahora por las plazas adicionales por el resto de tu período de facturación actual. A partir del {{date}}, tu suscripción tendrá {{count}} plazas y se renovará por {{amount}} cada {{interval}}.",

  // Subscription Types
  "subscription.manage.type.yearly": "Suscripción anual",
  "subscription.manage.type.monthly": "Suscripción mensual",
};

export const subscriptionManage = {
  ...subscriptionManageKeys,
};
